import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogModule,
} from '@angular/material/dialog';
import { TitleService } from '@shared/services';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'app-confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrls: ['./confirmation-dialog.component.scss'],
	imports: [MatDialogModule, MatButtonModule],
	standalone: true,
})
export class ConfirmationDialog {
	enableButtons = false;

	constructor(
		public dialogRef: MatDialogRef<ConfirmationDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private titleService: TitleService
	) {}

	onAllowClick(): void {
		this.dialogRef.close(true);

		this.titleService.announceMission('deleteAllow');
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}
}
